<script setup lang="ts">
const breakpoint = ref<string>('')

const isDevMode = import.meta.env.DEV
const updateBreakpoint = () => {
  const width = window.innerWidth
  if (width < 640) {
    breakpoint.value = 'sm'
  } else if (width < 768) {
    breakpoint.value = 'md'
  } else if (width < 1024) {
    breakpoint.value = 'lg'
  } else if (width < 1280) {
    breakpoint.value = 'xl'
  } else {
    breakpoint.value = '2xl'
  }
}

if (isDevMode) {
  onMounted(() => {
    updateBreakpoint()
    window.addEventListener('resize', updateBreakpoint)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', updateBreakpoint)
  })
}
</script>

<template>
  <div
    v-if="isDevMode"
    class="fixed right-4 bottom-4 z-40 m-4 rounded bg-black p-2 text-white shadow-lg"
  >
    Current Breakpoint: {{ breakpoint }}
  </div>
</template>
